module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/clQqJ0/cover.jpeg?1725276967935",
      "alt": "This image is the cover for the book A Year in the Life of Rebecca Saunders"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Year in the Life of Rebecca Saunders\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("New beginnings and a dark secret collide in Rebecca Saunders’ chaotic world. Frustrated by a jobless husband, unruly children, and rambunctious dogs, Becky seeks refuge in a quirky job working for Leo, a blustery wine importer with an attic office in his grand home. Leo’s wife, Fizz, adds to the unpredictable mix with her eccentric personality and champagne-cork temperament. Amidst the swirling chaos, Becky discovers a hidden secret that threatens the heart of her newfound sanctuary. Can she navigate the tangled vines of her own life while preserving the fragile peace she’s found?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Susie King\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Susie King has always loved writing stories and is highly imaginative, with a keen sense of the drama of life. Susie has been a chalet girl, daffodil picker, au pair, MP’s secretary, natural health therapist and went to a convent school where she was always getting into trouble. She loves travelling, going to the movies, trees, fish & chips, snow, the sea and anything to do with space.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0